<div
  class="layout-wrapper"
  [class.layout-theme-light]="layoutConfig().colorScheme === 'light'"
  [class.layout-theme-dark]="layoutConfig().colorScheme === 'dark'"
  [class.layout-overlay]="layoutConfig().menuMode === 'overlay'"
  [class.layout-static]="layoutConfig().menuMode === 'static'"
  [class.layout-static-inactive]="layoutState().staticMenuDesktopInactive && layoutConfig().menuMode === 'static'"
  [class.layout-overlay-active]="layoutState().overlayMenuActive"
  [class.layout-mobile-active]="layoutState().staticMenuMobileActive"
  [class.p-input-filled]="layoutConfig().inputStyle === 'filled'"
  [class.p-ripple-disabled]="!layoutConfig().ripple"
>
  <app-topbar (menuClicked)="menuClicked($event)" [locales]="languages()" />
  <div class="layout-sidebar"><app-sidebar class="app-sidebar" /></div>
  <p-button
    class="sidebar-collapsible white-bg collapsible-icon"
    [icon]="collapsibleIcon()"
    [rounded]="true"
    [text]="true"
    [raised]="true"
    (onClick)="layoutService.onMenuToggle()"
  />
  <div class="layout-main-container">
    <div class="layout-main"><router-outlet /></div>
  </div>
  <div class="layout-mask"></div>
</div>
<p-confirmDialog
  key="logout"
  [header]="'confirmation' | translate"
  icon="pi pi-exclamation-triangle"
  [style]="{ width: '40vw' }"
>
  <ng-template let-onAccept="onAccept" let-onReject="onReject">
    <p-button
      [text]="true"
      [outlined]="true"
      [label]="'no' | translate"
      icon="pi pi-times"
      class="mr-6"
      styleClass="p-confirm-dialog-reject"
      (onClick)="onReject()"
    />
    <p-button
      [label]="'yes' | translate"
      icon="pi pi-check"
      styleClass="p-confirm-dialog-accept"
      (onClick)="onAccept()"
    />
  </ng-template>
</p-confirmDialog>
<p-toast position="top-center" [life]="10000" />
<p-toast position="top-right" key="tr" [life]="10000" />
<p-dialog
  [header]="'defaultLanguage' | translate"
  [modal]="true"
  [(visible)]="dialogDefaultLanguage"
  [style]="{ width: '25rem' }"
>
  <form [formGroup]="languageForm" (ngSubmit)="saveLanguage()">
    <span class="p-text-secondary block mb-6">{{ 'select' | translate }} {{ 'defaultLanguage' | translate }}</span>
    <div class="flex items-center gap-4 mb-8">
      <label for="defaultLanguage" class="font-semibold w-24">{{ 'language' | translate }}</label>
      <p-select
        id="defaultLanguage"
        formControlName="defaultLanguage"
        [options]="languages() || []"
        [placeholder]="'selectOne' | translate"
        [showClear]="true"
        optionLabel="name"
        optionValue="iso"
        appendTo="body"
      >
        <ng-template let-language #item>{{ language.name }} ({{ language.endonym }})</ng-template>
        <ng-template let-language #selectedItem>{{ language.endonym }}</ng-template>
      </p-select>
    </div>
    <div class="flex justify-end gap-2">
      <p-button
        [text]="true"
        [outlined]="true"
        [label]="'cancel' | translate"
        icon="pi pi-times"
        class="mr-6"
        (onClick)="closeDefaultLanguageDialog()"
      />
      <p-button type="submit" icon="pi pi-file" [label]="'save' | translate" [disabled]="languageForm.invalid" />
    </div>
  </form>
</p-dialog>
